import React from "react";
import { useLocation } from "react-router";
import {
  EyeTestCode,
  eyeTestCodeToLabel,
  eyeCheckDue,
} from "../../services/data";
import { Link } from "react-router-dom";

import WhatHappensNextPositive from "../../components/activations/WhatHappensNextPositive";
import WhatHappensNextNegative from "../../components/activations/WhatHappensNextNegative";
import ReturnToHomepage from "../../components/activations/ReturnToHomepage";
import CongratsOnJoining from "../../components/activations/CongratsOnJoining";

export default function EyeCheckMessage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const lastEyeTestCode = (params.get("lastEyeTestCode")?.toLowerCase() ||
    "unknown_never") as EyeTestCode;
  const postcode = params.get("postcode");

  const requiresEyeCheck = eyeCheckDue(lastEyeTestCode);

  const renderedEyeCheckMessage = (() => {
    if (requiresEyeCheck === true) {
      return (
        <>
          <div className="mb-3">
            <div className="my-6 text-center bg-blue-100 p-4">
              <p className="mb-0 text-lg">
                You told us your last eye check was{" "}
                <strong>{eyeTestCodeToLabel(lastEyeTestCode)}</strong>
                <strong className="block mt-4">
                  Your next eye check is OVERDUE
                </strong>
              </p>
            </div>
            <p>
              Did you know that eye problems from diabetes can be developing
              even though your vision seems okay?
            </p>
            <p>
              <strong>More frequent checks</strong> may be necessary if you have
              pre-existing diabetes related eye diseases like diabetic
              retinopathy or if your eye care provider considers you to be at a
              higher risk of eye disease.
            </p>
            <p>
              Book one with your previous provider or if you need to find one
              then use our search tool.
            </p>
          </div>
          <div className="flex items-center mt-2 justify-center gap-4">
            <Link
              className="btn btn-secondary"
              to={`/activations/find_own_provider`}
            >
              No, I'll find one myself
            </Link>
            <a
              className="btn btn-primary"
              href={`/provider_search?query=${postcode}`}
            >
              YES, find me a provider
            </a>
          </div>
          <hr className="my-6" />
          <WhatHappensNextNegative />
        </>
      );
    } else {
      return (
        <>
          <div className="my-6 text-center bg-blue-100 p-4">
            <strong className="text-2xl block mb-2">Thank you!</strong>
            {lastEyeTestCode && (
              <p className="mb-0 text-lg">
                You told us your last eye check was{" "}
                <strong>{eyeTestCodeToLabel(lastEyeTestCode)}</strong>
              </p>
            )}
          </div>
          <p>
            Regular eye checks help protect your vision and it's recommended
            people with diabetes get eye checks at least every two years.
          </p>
          <p>
            <strong>More frequent checks</strong> may be necessary if you have
            pre-existing diabetes related eye diseases like diabetic retinopathy
            or if your eye care provider considers you to be at a higher risk of
            eye disease.
          </p>
          <p className="p-4 bg-blue-100 text-center text-lg">
            <strong>
              We'll send you a reminder when your next eye check is due.
            </strong>
          </p>
          <hr className="my-6" />
          <WhatHappensNextPositive />
        </>
      );
    }
  })();

  return (
    <>
      <CongratsOnJoining />
      {renderedEyeCheckMessage}
      <ReturnToHomepage />
    </>
  );
}
